// frontend/src/components/book/FeedbackSection.jsx
import React, { useState } from 'react';
import { api } from '../../api';
import { colors, fontFamily } from '../../theme';

export default function FeedbackSection() {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!subject.trim() || !message.trim()) {
      alert('Subject and message are required');
      return;
    }
    setSending(true);
    try {
      await api.sendMessage(subject, message, null, false, true);
      setSubject('');
      setMessage('');
      setSent(true);
      setTimeout(() => setSent(false), 3000);
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to send feedback');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ color: colors.textPrimary, fontFamily }}>
      <h2 style={{ marginBottom: '1rem' }}>Feedback</h2>
      <div style={{ background: colors.cardBg, boxShadow: colors.shadowCard, borderRadius: 8, padding: '1.25rem', maxWidth: 560 }}>
        <label style={{ display: 'block', fontSize: '0.85rem', color: colors.textMuted, marginBottom: 4 }}>Subject</label>
        <input
          value={subject}
          onChange={e => setSubject(e.target.value)}
          style={{ width: '100%', background: 'rgba(0,0,0,0.3)', color: colors.textPrimary, border: `1px solid ${colors.goldMuted}`, borderRadius: 4, padding: '0.5rem 0.75rem', marginBottom: '0.75rem', boxSizing: 'border-box' }}
        />
        <label style={{ display: 'block', fontSize: '0.85rem', color: colors.textMuted, marginBottom: 4 }}>Message</label>
        <textarea
          value={message}
          onChange={e => setMessage(e.target.value)}
          rows={5}
          style={{ width: '100%', background: 'rgba(0,0,0,0.3)', color: colors.textPrimary, border: `1px solid ${colors.goldMuted}`, borderRadius: 4, padding: '0.5rem 0.75rem', marginBottom: '0.75rem', boxSizing: 'border-box', fontFamily }}
        />
        <button
          onClick={submit}
          disabled={sending}
          style={{ background: colors.goldActiveBg, border: `1px solid ${colors.gold}`, color: colors.textPrimary, borderRadius: 6, padding: '0.6rem 1.5rem', cursor: 'pointer', fontWeight: 700, fontFamily }}
        >
          {sending ? 'Sending...' : 'Send Feedback'}
        </button>
        {sent && <p style={{ color: colors.odds, marginTop: '0.75rem' }}>Sent!</p>}
      </div>
    </div>
  );
}
